import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../constants/Endpoints/EndPoints";
import { FetchRequestHandler } from "../../../utils/commonUtilities";

export const fetchServicesProvider = createAsyncThunk(
    "fetchServicesProvider",
     async (practiceId) => {
        const result = await FetchRequestHandler(
          "get",
          `${baseUrl}api/practices/${practiceId}/providers?view=brief&filter-by=active`
        );
        return result;
      }
)

export const fetchServicesChecklist = createAsyncThunk(
    "fetchServicesChecklist",
    async () => {
      const result = await FetchRequestHandler(
        "get",
        `${baseUrl}api/provided-services`
      );
      return result;
    }
)

export const fetchServicesListItems = createAsyncThunk(
    "fetchServicesListItems",
    async ({practiceId, providerId}) => {
      const result = await FetchRequestHandler(
        "get",
        `${baseUrl}api/practices/${practiceId}/providers/${providerId}/provided-services`
      );
      return result;
    }
)

export const updateServiceList = createAsyncThunk(
    "updateServiceList",
    async ({practiceId, data, providerId}) => {
      const result = await FetchRequestHandler(
        "put",
        `${baseUrl}api/practices/${practiceId}/providers/${providerId}/provided-services`,
        data
      );
      return result;
    } 
)